import { Pipe, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DEFAULT_MESSAGE_ERROR } from '../payment-result/messages';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) { }

  public makePayment(reqBody: any): Observable<any> {
    return this.http.post(environment.settings.Decidir2ApiUrl.concat('makePayment'), reqBody, this.httpOptions);
    // return this.http.post(('http://localhost:8882/makePayment'), reqBody, this.httpOptions);
  }

  public makeOfflinePayment(reqBody: any): Observable<any> {
    return this.http.post(environment.settings.Decidir2ApiUrl.concat('makeOfflinePayment'), reqBody, this.httpOptions);
  }

  public makePaymentErrr(response = null): Observable<any> {
    const ErrObservable = new Observable(observer => {
      observer.error({
        error: {
          actualizado: '',
          statusCode: 400,
          data: DEFAULT_MESSAGE_ERROR,
          statusDetail: 'decidir_exception'
        }
      });
    });
    return ErrObservable;
  }

  getBines(reqBody: any): Observable<any> {
    const url = `${environment.settings.Decidir2ApiUrl}getBines`;
    return this.http.post(url, reqBody, this.httpOptions);
  }

  paywayTokenize(data) {
    let httpOptions = this.httpOptions;
    const apiKey = environment.settings.DecidirPublicKey;
    httpOptions = { headers: this.httpOptions.headers.set('apiKey', apiKey) };
    const url = `${environment.settings.urlPayway}/tokens`;
    return this.http.post(url, data, httpOptions);
  }

  paywayTokenizeOffline(data) {
    let httpOptions = this.httpOptions;
    const apiKey = environment.settings.DecidirPublicKey;
    httpOptions = { headers: this.httpOptions.headers.set('apiKey', apiKey) };
    const url = `${environment.settings.UrlDecidir}/tokens`;
    return this.http.post(url, data, httpOptions);
  }

}
